import { Router } from '@angular/router';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ElementRef,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { CommonApiService } from 'src/helper/common-api.service';
import { CommonHelper } from 'src/helper/common-helper';
import { MessageService } from 'src/helper/message.service';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
})
export class IndexComponent implements OnInit, OnDestroy {
  apiUrl = environment.apiUrl;
  getSliderArray: any = [];
  getSemonArray: any = [];
  videoStatus: boolean;
  getEventArray: any = [];
  IndexSection2Title = '';
  AnnouncementText: string;
  youTubeId: any;
  languageData: any;

  constructor(
    private commonApiService: CommonApiService,
    private ref: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private router: Router,
    private CommonHelper: CommonHelper,
    private messageService: MessageService,
    private config: NgbCarouselConfig
  ) {}
  ngOnDestroy(): void {}

  ngOnInit(): void {
    //  this.config.interval = 3000;
    this.config.showNavigationArrows = false;
    this.config.showNavigationIndicators = false;
    this.config.pauseOnFocus = false;
    this.config.pauseOnHover = false;
    this.loadText();
    this.CommonHelper.retrieveMappedCommonObjectObject().subscribe((t) => {
      this.loadText();
    });

    this.languageTrack();
  }

  languageTrack() {
    this.commonApiService
      .getPromiseResponse({
        apiName: `/api/courses/language_track`,
        methodType: 'get',
        parameterObject: null,
      })
      .then((result: any) => {
        this.languageData = result;
        var chineseObject = { language: 'Chinese', languageid: 2 };
        this.languageData.push(chineseObject);
        console.log(result);

        // for language sorting 
        const englishItem = this.languageData.find(
          (data) => data.language === 'English'
        );
        this.languageData = this.languageData.filter(
          (data) => data.language !== 'English'
        );
        this.languageData.sort((a, b) => a.language.localeCompare(b.language));
        this.languageData.unshift(englishItem);
      })
      .catch((q) => {
        console.log(q);
      });
  }

  route(trackName: any, trackId: any, languageId: any) {
    if (languageId == 13) {
      var select: any = document.querySelector('.goog-te-combo');
      select.value = 'ru';
      select.dispatchEvent(new Event('change'));
    }
    if (languageId == 14) {
      var select: any = document.querySelector('.goog-te-combo');
      select.value = 'es';
      select.dispatchEvent(new Event('change'));
    }

    setTimeout(() => {
      if (trackId == 1) {
        this.router.navigate([
          '/itim-ministry-tracks/Discipleship/' + languageId,
        ]);
      } else if (trackId == 2) {
        this.router.navigate([
          '/itim-ministry-tracks/Church-Ministry/' + languageId,
        ]);
      } else if (trackId == 3) {
        this.router.navigate([
          '/itim-ministry-tracks/Church-Leadership/' + languageId,
        ]);
      } else if (trackId == 4) {
        this.router.navigate([
          '/itim-ministry-tracks/BibleTeaching/' + languageId,
        ]);
      } else if (trackId == 5) {
        this.router.navigate([
          '/itim-ministry-tracks/pastoral-ministry-track/' + languageId,
        ]);
      }
    }, 10);
  }

  loadText() {
    this.IndexSection2Title = CommonHelper.CommonDetails.IndexSection2Title;
    this.AnnouncementText = CommonHelper.CommonDetails.AnnouncementText;
  }

  // getSliderDetail() {
  //   this.commonApiService.getPromiseResponse({
  //     apiName:'/sliderimage',methodType:'get',parameterObject: null,showLoading:true
  //   }).then((result:any) => {
  //      this.getSliderArray = result;
  //   }).catch((err:any)=>{
  //   })
  // }

  // getSermonsDetail() {
  //   this.commonApiService.getPromiseResponse({
  //     apiName: '/semon', methodType: 'get', parameterObject: null,showLoading:true
  //   }).then((result: any) => {
  //     this.getSemonArray = result;
  //     this.ref.detectChanges()
  //   }).catch((err: any) => {
  //   })
  // }

  securityByPass(url: any) {
    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }

  // getVideoStatus() {
  //   this.commonApiService.getPromiseResponse({
  //     apiName:'/youtubelive',methodType:'get',parameterObject:null,showLoading:true
  //   }).then((result:any) => {
  //     this.videoStatus = result.status;
  //   }).catch((err:any) => {
  //   });
  // }

  // getEventDetail() {
  //   this.commonApiService.getPromiseResponse({
  //     apiName:'/event',methodType:'get',parameterObject: null
  //   }).then((result:any) => {
  //     result.forEach(element => {
  //       if(new Date(element.eventTime+'.000Z').getTime() >= new Date().getTime())
  //       {
  //         this.getEventArray.push(element);
  //       }
  //       else if(element.isRecuuring)
  //       {
  //         this.getEventArray.push(element);
  //       }
  //     });
  //   }).catch((err:any)=>{
  //   })
  // }

  handleSemonsClick(item: any) {
    this.router.navigate(['view'], { queryParams: { id: item } });
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
  convertToLocalDate(utcDate) {
    var date = new Date(utcDate + '.00Z');
    return date.toString();
  }

  handleWatchLive() {
    if (this.youTubeId) {
      this.router.navigate(['view'], { queryParams: { id: this.youTubeId } });
    } else {
      this.messageService.successMessage('No YouTube Live Is Going On');
    }
  }

  // hanldeGetYoutubeLiveDetails()
  // {
  //   this.commonApiService.getPromiseResponse({
  //     apiName:'/youtubelive/details',methodType:'get',parameterObject:null,showLoading:true
  //   }).then((result:any) => {
  //     this.youTubeId = result.youTubeId
  //   }).catch((err:any) => {
  //   });
  // }
  trackByIframe(index, ele) {
    return ele.id;
  }
}
